import React from 'react';
import NoSSR from 'react-no-ssr';
import Chip from 'Chip';
import PropTypes from 'prop-types';
import styles from './index.css';
import UserInfo from '@ifeng-fe/ui_pc_userInfo';
import Search from '@ifeng-fe/ui_pc_search';
import errorBoundary from '@ifeng-fe/errorBoundary';
import AreaStaticChip from '@ifeng-fe/container_content/common/client/components/areaStaticChip';
import Nav from '../../../components/nav';
import Logo from './logo/';

class Header extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染网页布局
     */
    render() {
        const { content } = this.props;
        const { nav, search, logo, domain, breadCrumbdata, chipObj, topAd, logoAd } = content;
        const logoData = { logo, domain, breadCrumbdata };

        return (
            <div>
                <div className={styles.header}>
                    <Nav content={nav} />
                    <div className={styles.user}>
                        <NoSSR>
                            <UserInfo />
                        </NoSSR>
                    </div>
                </div>
                <div className={styles.top_box}>
                    <NoSSR>
                        <Chip
                            id={chipObj.topAd}
                            type="static"
                            title="顶部广告"
                            groupName="头部"
                            translate="handleAreaAd"
                            content={topAd}>
                            <AreaStaticChip styleName={styles.chip_box} />
                        </Chip>
                    </NoSSR>
                </div>
                <div className={styles.search_bar}>
                    <Logo content={logoData} chipObj={chipObj} logoAd={logoAd} />
                    <NoSSR>
                        <Chip id="20005" type="struct" title="搜索" groupName="头部" content={search}>
                            <Search />
                        </Chip>
                    </NoSSR>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Header);
